import { Button } from '#/components/ui/button';
import { Input } from '#/components/ui/input';
import { useEffect, useState } from 'react';

import type { SearchBoxStyles } from '../styles';
import { SvgIconDeleteKeyword } from '../svg/icon-delete-keyword';
import { SvgIconSearchButton } from '../svg/icon-search-button';

export type SearchBoxProps = {
  styles: SearchBoxStyles;
  placeholderText?: string;
  keyword?: string;
  onKeywordChange?: (value: string) => void;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  name?: string;
};

export default function SiteSearchBox({
  styles,
  placeholderText,
  keyword,
  onKeywordChange,
  inputRef,
  name = 'keyword',
}: SearchBoxProps) {
  const [value, setValue] = useState(keyword ?? '');

  // 外部からkeywordが変更された時に内部状態を更新
  useEffect(() => {
    setValue(keyword ?? '');
  }, [keyword]);

  return (
    <div className={styles.base}>
      <div className={styles.box}>
        <Input
          aria-label="campaign検索"
          className={styles.input}
          placeholder={placeholderText}
          autoComplete="off"
          type="search"
          inputMode="text"
          ref={inputRef}
          maxLength={100}
          value={value}
          name={name}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (!inputRef?.current && e.key === 'Enter') {
              e.preventDefault();
              onKeywordChange?.(value);
            }
          }}
        />
        {value && (
          <Button
            type="button"
            size="icon"
            className={styles.clear}
            aria-label="キーワードを削除する"
            onClick={() => {
              setValue('');
              inputRef?.current?.focus();
            }}>
            <SvgIconDeleteKeyword className="text-grey-400 size-6 flex-none" />
          </Button>
        )}
      </div>
      <Button type="submit" className={styles.button} onClick={() => onKeywordChange?.(value)}>
        <SvgIconSearchButton width={18} height={19} />
      </Button>
    </div>
  );
}
